/**
 * Отзывы пользователей для главной страницы.
 *
 * ЗАЧЕМ ЭТО НУЖНО
 * ---------------
 * В JSON-LD главной есть `aggregateRating` (4.9 из Chrome Web Store).
 * Google требует, чтобы разметка соответствовала тому, что видит
 * пользователь на странице. Пока этот массив пуст, рейтинг в разметке
 * не выводится вообще — см. `hasReviews()` ниже и
 * `softwareApplicationSchema` в src/utils/seo.js.
 *
 * ПРАВИЛА
 * -------
 * Только настоящие отзывы из Chrome Web Store, скопированные ДОСЛОВНО.
 * Опечатки, строчные буквы и смайлики сохраняются: «причёсанный» отзыв
 * читается как написанный маркетологом, то есть ровно наоборот тому,
 * зачем он здесь. Ничего не сочинять — выдуманный отзыв это основание
 * для ручных санкций и обман читателя.
 *
 * Поле `rating` не заполняется: сколько звёзд поставил каждый автор,
 * из карточки не видно, а угадывать нельзя. Общая оценка берётся из
 * STORE_STATS и подписана ссылкой на источник.
 *
 * ЧТО СОЗНАТЕЛЬНО НЕ ВЗЯТО
 * ------------------------
 * Из последних отзывов осталось за бортом два критических:
 *  - отзыв Ryan (20.03.2025) — самый содержательный из критических, но
 *    в нём названы суммы, а цены мы на сайте нигде не публикуем;
 *  - отзыв Federico José Garip (23.04.2025) — «I don't recommend to use
 *    this»; он про лимит бесплатной версии, который мы и так честно
 *    описываем.
 * Оба настоящие, и добавить их — вопрос решения, а не правки кода.
 *
 * @see questions.md, вопрос Q6
 */

const reviews = [
	{
		text:
			'really good app!! i love the amount of widgets and customization options available, and everything has been running smoothly so far :)',
		author: 'akaru',
		date: '2026-06-23',
	},
	{
		text:
			'Awesome extension. Does what is says on the tin, and makes it simple.',
		author: 'Anthony Lenton',
		date: '2026-06-08',
	},
	{
		text: 'Good for my exam countdown.',
		author: 'Yashoda Bandara',
		date: '2026-01-26',
	},
	{
		text:
			'best for its mutiple countdowns,like days,weeks,minutes,even sec all at once and seperated...',
		author: 'archit yadav',
		date: '2026-01-13',
	},
	{
		text:
			'so many different features. love the ability to have different workspaces for different needs easily.',
		author: 'Nipuni JM',
		date: '2025-06-21',
	},
	{
		text:
			'Good features like week targets and habit tracker with counter is helpful.',
		author: 'jarvis',
		date: '2024-12-16',
	},
	{
		text:
			'Amazing application has really helped me to be more organized and plan out my upcoming events and remain more focused',
		author: 'Lerm da kiwi',
		date: '2024-10-17',
	},
	{
		text: "Good but I can't edit my sticky notes for some reason right now",
		author: 'Vivian Le',
		date: '2025-08-12',
	},
];

export default reviews;

/** Есть ли на сайте отзывы, которые видит пользователь. */
export function hasReviews() {
	return reviews.length > 0;
}
